import { Card } from "../ui/card";
import { Label } from "../ui/label";
import { RadioGroup, RadioGroupItem } from "../ui/radio-group";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Zap, MousePointerClick, UserCheck } from "lucide-react";

const MODES = [
  ["fcfs", "First Come First Served", "Il primo partner che accetta blocca la corsa automaticamente.", Zap],
  ["manual", "Selezione Manuale", "I partner si candidano e la C.O. sceglie a chi assegnare.", MousePointerClick],
  ["direct", "Assegnazione Diretta", "Assegna subito a un partner specifico, senza pubblicarla agli altri.", UserCheck],
];

export const EngagementSection = ({ mode, setMode, disabled, isEdit, partners, directPartnerId, setDirectPartnerId }) => (
  <Card className="p-6 border-slate-200 mb-5">
    <Label className="nx-label mb-3 block">Algoritmo di Ingaggio</Label>
    <RadioGroup value={mode} onValueChange={setMode} disabled={disabled} className="grid grid-cols-1 md:grid-cols-3 gap-3">
      {MODES.map(([value, title, desc, Icon]) => (
        <label key={value} htmlFor={`m-${value}`} className={`flex items-start gap-3 rounded-lg border p-4 cursor-pointer transition-colors ${mode === value ? "border-primary bg-primary/5" : "border-slate-200"}`}>
          <RadioGroupItem value={value} id={`m-${value}`} data-testid={`mode-${value}`} className="mt-0.5" />
          <div>
            <div className="flex items-center gap-1.5 font-semibold text-sm text-slate-800"><Icon className="h-4 w-4 text-primary" /> {title}</div>
            <p className="text-xs text-slate-500 mt-1">{desc}</p>
          </div>
        </label>
      ))}
    </RadioGroup>
    {mode === "direct" && !isEdit && (
      <div className="mt-4 max-w-sm">
        <Label className="nx-label">Partner assegnatario</Label>
        <Select value={directPartnerId} onValueChange={setDirectPartnerId}>
          <SelectTrigger data-testid="direct-partner" className="mt-1.5"><SelectValue placeholder="Seleziona partner" /></SelectTrigger>
          <SelectContent>{partners.map((p) => <SelectItem key={p.id} value={p.id}>{p.name}</SelectItem>)}</SelectContent>
        </Select>
      </div>
    )}
  </Card>
);
